import React from 'react';
import { Link } from 'react-router-dom';
import '../components/Polymathy.css';
import './ServicesPage.css';

const ServicesPage = () => {
  const serviceCategories = [
    {
      id: 'grc',
      title: 'Governance, Risk & Compliance (GRC)',
      subtitle: 'Strategic Advisory',
      description: 'Comprehensive GRC architecture, board advisory, audit & assurance, business excellence, and integrated policy frameworks.',
      icon: 'fas fa-shield-alt',
      link: '/services/grc',
      color: '#D6AD60'
    },
    {
      id: 'financial',
      title: 'Financial Services',
      subtitle: 'Financial Strategy & Operations',
      description: 'Strategic financial advisory, CFO-level insights, financial reporting, taxation, budgeting, and comprehensive financial transformation.',
      icon: 'fas fa-chart-line',
      link: '/services/financial',
      color: '#D6AD60'
    },
    {
      id: 'workforce',
      title: 'Strategic Talent & Workforce Solutions',
      subtitle: 'Co-sourcing & Outsourcing',
      description: 'Flexible workforce solutions including co-sourcing and outsourcing models to supplement your team with specialized expertise.',
      icon: 'fas fa-users',
      link: '/services/workforce',
      color: '#D6AD60'
    }
  ];

  return (
    <section className="polymathy-section">
      <div className="container">
        <div className="polymathy-header">
          <h2 className="section-title center">OUR SERVICES</h2>
          <div className="title-underline center"></div>
          <p className="polymathy-subtitle">
            Comprehensive solutions across Governance, Finance, and Workforce Management
          </p>
        </div>

        <div className="services-cards-grid">
          {serviceCategories.map((category) => (
            <Link
              key={category.id}
              to={category.link}
              className="service-category-card"
            >
              <div className="service-card-icon">
                <i className={category.icon}></i>
              </div>
              <h3 className="service-card-title">{category.title}</h3>
              <p className="service-card-subtitle">{category.subtitle}</p>
              <p className="service-card-description">{category.description}</p>
              <div className="service-card-arrow">
                <i className="fas fa-arrow-right"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesPage;
